/**
 * Module for sToast
 * @module services/sToast
 * @preferred
 */
import singletons from "@/services/singletons";

let loaderMobile = {
  get show() {
    return singletons.loaderMobile.show;
  },
  get hide() {
    return singletons.loaderMobile.hide;
  },
  get progress() {
    return singletons.loaderMobile.progress;
  }
};
export default loaderMobile;
